import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: #e9edf5;
`;

export const FooterWrapper = styled.div`
  max-width: 1140px;
  padding: 12px 24px;
  display: flex;
  width: 85%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  z-index: 1;
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  // justify-content: center;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    width: 100vw;
    padding: 1rem;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-self: center;
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;
    flex-grow: 1;
  }
`;

export const FooterLogoWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-right: 1rem;
  padding-top: 0.4rem;
  color: #052e69;
  font-family: "Kanit", sans-serif;
  // align-items: center;
  // text-align: left;
  // margin: 16px;
  // margin-left: -110px;
  // width: 112px;
  // box-sizing: border-box;

  // @media screen and (max-width: 820px) {
  //   margin-top: -240px;
  //   width: 30%;
  // }

  @media screen and (max-width: 900px) {
    margin-bottom: 1rem;
    justify-content: center;
  }
`;

export const FooterLogo = styled.img`
  margin-right: 0.5rem;
`;

export const FooterLogoText = styled.div`
  align-self: start;

  @media screen and (max-width: 768px) {
    align-self: center;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 6px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: #052e69;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }

  @media screen and (max-width: 900px) {
    flex-grow: 1;
    padding: 0.5rem;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 14px;
  margin-bottom: 6px;
  font-family: "Kanit", sans-serif;
`;

export const FooterLink = styled(Link)`
  color: #052e69;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-family: "Kanit", sans-serif;

  &:hover {
    color: #30c1ff;
    transition: 0.3s ease-out;
  }
`;

export const FooterLinkA = styled.a`
  color: #052e69;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-family: "Kanit", sans-serif;

  &:hover {
    color: #30c1ff;
    transition: 0.3s ease-out;
  }
`;

export const FooterText = styled.p`
  color: #052e69;
  text-decoration: none;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
  line-height: 1rem;
  width: 520px;
  box-sizing: border-box;
  font-family: "Kanit", sans-serif;

  @media screen and (max-width: 980px) {
    width: 100%;
  }

  @media screen and (max-width: 780px) {
    width: 300px;
  }
`;

export const WebsiteRights = styled.div`
  color: #052e69;
  margin-bottom: -8px;
  margin-top: 0px;
  font-family: "Kanit", sans-serif;

  display: flex;
  flex-direction: row;
  gap: 1rem;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;

export const WebRightSbl = styled.div``;

export const WebRightSeparator = styled.div`
  @media screen and (max-width: 480px) {
    display: none;
  }
`;

export const WebRightAlas = styled.div``;
